import {
  Button,
  TextField,
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useState } from 'react';
import useRequestStore from '../../../store/request';

export default function RequestPersonalData({ next, back }) {
  const data = useRequestStore((state) => state.data);
  const [preferred, setPreferred] = useState(data.preferred || 'email');

  function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    next({ ...data, preferred });
  }

  function handleBack(e) {
    const formData = new FormData(e.target.closest('form'));
    const data = Object.fromEntries(formData);
    back({ ...data, preferred });
  }

  return (
    <>
      <Box sx={{ mb: '16px' }}>
        <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>
          Kontaktdaten
        </Typography>
        <Typography sx={{ fontSize: '14px' }}>
          Wie werden Sie am liebsten kontaktiert? Wählen Sie das entsprechende
          Feld bitte aus.
        </Typography>
      </Box>
      <Box
        component="form"
        onSubmit={(evt) => handleSubmit(evt)}
        sx={{ display: 'flex', flexFlow: 'column', gap: '16px' }}
      >
        <TextField
          label="Firma"
          name="company"
          autoComplete="organization"
          required
          defaultValue={data.company}
        />
        <TextField
          label="Vor- und Nachname"
          autoComplete="name"
          autoCapitalize="words"
          name="name"
          required
          defaultValue={data.name}
        />
        <TextField
          label="E-Mail"
          name="email"
          type="email"
          autoComplete="email"
          defaultValue={data.email}
          required
          slotProps={{
            input: {
              endAdornment: (
                <ToggleButtonGroup sx={{ display: 'contents' }}>
                  <ToggleButton
                    size="small"
                    color="primary"
                    selected={preferred === 'email'}
                    onChange={() => setPreferred('email')}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    E-Mail
                  </ToggleButton>
                  <ToggleButton
                    size="small"
                    color="primary"
                    selected={preferred === 'teams'}
                    onChange={() => setPreferred('teams')}
                  >
                    Teams
                  </ToggleButton>
                </ToggleButtonGroup>
              ),
            },
          }}
        />
        {/* prettier-ignore */}
        <TextField
          label="Telefon"
          name="phone"
          type="tel"
          autoComplete='tel'
          defaultValue={data.phone}
          slotProps={{ 
            // eslint-disable-next-line no-useless-escape
            htmlInput: { pattern: '[\+]?[0-9 ]+' }, 
            input: { endAdornment: <ToggleButton size="small" color="primary" selected={preferred === "phone"} onChange={() => setPreferred("phone")}>TELEFON</ToggleButton>}
          }}
          placeholder="+49 1234 5678910"
          required={preferred === 'phone'}
        />
        <Button
          type="submit"
          name="next"
          variant="contained"
          sx={{
            borderRadius: 0,
            color: 'white',
            boxShadow: 'none !important',
            '&:hover': {
              backgroundColor: '#19BB5D',
            },
          }}
        >
          Senden
        </Button>
        <Button
          onClick={handleBack}
          name="back"
          variant="text"
          sx={{ mt: '-8px' }}
        >
          Zurück
        </Button>
      </Box>
    </>
  );
}
